import styled from "styled-components";

interface SquareInfoProps {
  title: string;
  number: number;
}

export function SquareInfo({ title, number }: SquareInfoProps) {
  return (
    <Content>
      <Title>{ title }</Title>
      <Number>{ number }</Number>
    </Content>
  );
}

const Content = styled.div`
  width: 100%;
  max-width: 280px;
  height: 280px;
  border-radius: 3px;
  position: relative;
  margin: 0 8px;
  background-color: ${({ theme }) => theme.colors.blue.dark};

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    max-width: none;
    height: 100px;
    margin: 8px 0;
  }
`;

const Title = styled.span`
  display: block;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.pink.light};
  font-family: 'Coolvetica Condensed',Arial,Helvetica,sans-serif;
  position: absolute;
  bottom: 20px;
  left: 20px;
  font-size: 36px;
  max-width: 180px;
  line-height: 1;
`;

const Number = styled.span`
  color: #fff;
  position: absolute;
  top: 8px;
  right: 20px;
  font-size: 60px;
`;